import { useQuery } from "@tanstack/react-query";
import MaterialIconsReact from "material-icons-react";
import { useContext, useEffect, useState } from "react";
import Filter from "../../components/Filter";
import Tag from "../../components/Tag";
import { UserContext } from "../../context/UserContext";
import { fetchBoardData, fetchMaterialImage, fetchSwatchData } from "../../services/station";
import styles from './BoardView.module.css';

function BoardView() {
  const {workOrder, selectedLocation, currentFactory, toastList, setToastList} = useContext(UserContext);
  const [imageMap, setImageMap] = useState(undefined);

  const {data: boardData, isLoading} = useQuery(['boardData', workOrder], async () => {
    const response = await fetchBoardData(
      {
        location: selectedLocation.location,
        _factory_code: currentFactory.item_code,
        stockpile_id: workOrder.id,
        skip_position: true
      }
    )
    if (response.status === 200) {
      return formatData(response.message)
    } else {
      setToastList([...toastList, {
        type: 'error',
        text: response.message || 'Internal Server Error',
        autoClose: false
      }]);
      return {filteredData: []};
    }
  }, {
    refetchOnWindowFocus: false
  })

  const formatData = (boardDetails) => {
    let filteredData = [];
    for (var i=0; i < boardDetails.material_position.length; i++) {
      // check for beamsaw
      let data = boardDetails.material_position[i];
      if (data.material.split('_').length === 3) {
        let bookdata = boardDetails.books.filter((item) => item.material === data.material);
        if (bookdata.length > 0) {
          data.cut_part = 0;
          data.total_board = 0;
          data.cut_board = 0;
          data.total_part = 0
          bookdata.map((book) => {
            data.cut_part += (book.cut_parts);
            data.total_part += (book.parts_count);
            if (book.cut_parts > 0) {
              data.cut_board += book.boardcount;
            }
            data.total_board += book.boardcount;
          })
        }
        filteredData.push(data);
      }
    }
    boardDetails.filteredData = filteredData;
    return boardDetails;
  }

  // const getImage = async (itemCode) => {
  //   const swatchData = await fetchSwatchData({
  //     item_code: itemCode
  //   });
  //   if (typeof swatchData.message !== 'string') {
  //     const imageData = await fetchMaterialImage({
  //       docid: swatchData.message.swatch_id
  //     })
  //     return 'data:image/png;base64,' + imageData.message.data;
  //   } 
  //   return '';
  // }

  // useEffect(() => {
  //   if (boardData && boardData.material_position.length > 0) {
  //     let imageMapCopy = imageMap || {};
  //     boardData.material_position.map(async (item) => {
  //       if (item.stock_type !== 'ONLY_HOTPRESS' || !boardData.boardMap[item.prep_surface_1]) {
  //         return;
  //       }
  //       let itemCode = boardData.boardMap[item.prep_surface_1].item_code;
  //       if (!imageMapCopy[itemCode]) {
  //         imageMapCopy[itemCode] = await getImage(itemCode);
  //       }
  //     })
  //     setImageMap(imageMapCopy);
  //   }
  // }, [boardData])

  if (isLoading) return <div style={{textAlign: 'center'}}>Please wait while we are loading board details. Nevertheless, Barcode scanning will still work</div>

  return (
    <>
      <div className={styles.boardHeader}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <span style={{fontWeight: 700}}>Board Types</span> <span className="ft-12" style={{fontWeight: 400, marginLeft: '4px'}}>({boardData.filteredData.length})</span>
          {/* <Filter></Filter> */}
        </div>
        {/* <div style={{display: 'flex', alignItems: 'center'}}>
          <MaterialIconsReact icon="sort" size={20}></MaterialIconsReact> 
          <span className={"ft-14"} style={{margin: 'auto 8px'}}>Sort by</span>
          <MaterialIconsReact icon="expand_more" size={20}></MaterialIconsReact>
        </div> */}
      </div>
      <div className="table-responsive">
        <table className="table block">
          <thead>
            <tr>
              <th className="ft-12">Board Details</th>
              <th className="ft-12">Board QTY</th>
              <th className="ft-12">Panel QTY</th>
              <th className="ft-12">Status</th>
            </tr>
          </thead>
          <tbody>
            {
              boardData.filteredData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <div style={{display: 'flex', flexDirection: 'row'}}>
                        {/* <div style={{display: 'flex', gap: '4px', marginRight: '16px'}}>
                          {imageMap && <img className={styles.materialImage} src={imageMap[boardData.board_map[item.prep_surface_1].item_code]}></img>}
                          {imageMap && <img className={styles.materialImage} src={imageMap[boardData.board_map[item.core_material].item_code]}></img>}
                          {imageMap && <img className={styles.materialImage} src={imageMap[boardData.board_map[item.prep_surface_2].item_code]}></img>}
                        </div> */}
                        <div title={item.material}>
                          <div style={{marginBottom: '2px', fontWeight: 'bold'}}>{item.material}</div>
                          <div>{boardData.board_map[item.prep_surface_1]?.notes || boardData.board_map[boardData.board_map[item.material].prep_surface_1]?.notes}</div>
                          <div>{boardData.board_map[item.core_material]?.notes || boardData.board_map[boardData.board_map[item.material].core_material]?.notes}</div>
                          <div>{boardData.board_map[item.prep_surface_2]?.notes || boardData.board_map[boardData.board_map[item.material].prep_surface_2]?.notes}</div>
                        </div>
                      </div>
                    </td>
                    <td>{item.cut_board + ' / ' + item.total_board}</td>
                    <td>{item.cut_part + ' / ' + item.total_part}</td>
                    <td>
                      {item.cut_part === item.total_part ? 
                      <Tag type='primary' fillStyle='outline' icon={'check_circle'}>Completed</Tag> : 
                      <Tag type='tertiary' fillStyle='filled'>Pending</Tag>}
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </>
  );
}

export default BoardView;
